import { DeleteOutline } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";

import { IconButton, CircularProgress, Typography } from "@mui/material";
import React from "react";
import {
  InfoBox,
  ListContainer,
  StyledUserCard,
  AvatarCircle,
  StyledNameField,
  StyledTitleField,
  StyledRoleField,
} from "./styles";

interface IUser {
  id: number;
  name: string;
  cpf: string;
  role: "admin" | "normal";
}

interface UserListProps {
  users: IUser[] | null;
  onDelete?: (id: number) => void;
  onEdit?: any;
  deletingUserId?: number | null;
}

const UserList: React.FC<UserListProps> = ({
  users,
  onDelete,
  onEdit,
  deletingUserId,
}) => {
  const getInitials = (name: string) =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();

  return (
    <ListContainer>
      <StyledTitleField variant="h6">Lista de Usuários</StyledTitleField>

      <ul style={{ margin: 0, padding: 0 }}>
        {users && users.length > 0 ? (
          users.map((user) => (
            <StyledUserCard key={user.id}>
              <AvatarCircle sx={{ background: user.role === "admin" ? "#c62828" : "#0B3095" }}>{getInitials(user.name)}</AvatarCircle>
              <InfoBox>
                <StyledNameField>
                  {user.name}
                </StyledNameField>
                <Typography sx={{ fontSize: 14 }}>
                  CPF: {user.cpf}
                </Typography>
                {user.role === "admin" && (
                  <StyledRoleField>Administrador</StyledRoleField>
                )}
              </InfoBox>
              <IconButton onClick={() => onEdit(user)}>
                <EditIcon />
              </IconButton>


              <IconButton
                color="error"
                onClick={() => onDelete?.(user.id)}
                disabled={deletingUserId === user.id}
              >
                {deletingUserId === user.id ? (
                  <CircularProgress size={22} color="error" />
                ) : (
                  <DeleteOutline />
                )}
              </IconButton>
            </StyledUserCard>
          ))
        ) : (
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            Nenhum usuário encontrado.
          </Typography>
        )}
      </ul>
    </ListContainer>
  );
};

export default UserList;
